import { handleActions } from 'redux-actions';
import keyBy from 'lodash/keyBy';
import range from 'lodash/range';
import * as TYPES from 'constants/ActionTypes';

const yearNow = new Date().getFullYear();
const initialState = {
  documentTypes: [],
  documentTypesById: {},
  documentTypesByValue: {},
  error: null,
  files: [],
  fileById: {},
  groupedFiles: {},
  groupFilter: null,
  hasError: false,
  loaded: false,
  ownerTypes: [],
  payslips: [],
  payslipsLoaded: false,
  payYear: yearNow,
  payYearOptions: range(2010, yearNow + 1),
  uploadHasError: false,
  uploading: false,
};

// handleActions is a helper function to instead of using a switch case statement,
// we just use the regular map with function state attach to it.

export default handleActions({
  [TYPES.REQUEST_FILES]: state => ({
    ...state,
    loaded: false,
    hasError: false,
  }),
  [TYPES.REQUEST_FILES_SUCCESS]: (state, { files, groupedFiles }) => ({
    ...state,
    groupedFiles,
    files,
    loaded: true,
  }),
  [TYPES.REQUEST_FILES_FAILURE]: (state, { error }) => ({
    ...state,
    error,
    loaded: true,
    hasError: true,
  }),
  [TYPES.SET_PAY_YEAR]: (state, { payYear, payYearOptions }) => ({
    ...state,
    payYear,
    payYearOptions: payYearOptions || state.payYearOptions,
  }),
  [TYPES.SET_GROUP_FILTER]: (state, { groupFilter }) => ({
    ...state,
    groupFilter,
  }),
  [TYPES.REQUEST_PAYSLIPS]: state => ({
    ...state,
    payslipsLoaded: false,
    hasError: false,
  }),
  [TYPES.REQUEST_PAYSLIPS_SUCCESS]: (state, { payslips }) => ({
    ...state,
    payslips: payslips.map((s) => {
      const PayMonth = new Date(s.PayPeriodBegda).getMonth();
      return {
        ...s,
        PayMonth,
      };
    }),
    payslipsLoaded: true,
  }),
  [TYPES.REQUEST_PAYSLIPS_FAILURE]: (state, { error }) => ({
    ...state,
    error,
    payslipsLoaded: true,
    hasError: true,
  }),
  [TYPES.REQUEST_FILE_DOWNLOAD]: state => ({
    ...state,
    hasError: false,
  }),
  [TYPES.REQUEST_FILE_DOWNLOAD_SUCCESS]: state => ({
    ...state,
  }),
  [TYPES.REQUEST_FILE_DOWNLOAD_FAILURE]: (state, { error }) => ({
    ...state,
    hasError: true,
    error,
  }),
  [TYPES.REQUEST_FILE_DELETE]: state => ({
    ...state,
    uploadHasError: false,
  }),
  [TYPES.REQUEST_FILE_DELETE_SUCCESS]: state => ({
    ...state,
  }),
  [TYPES.REQUEST_FILE_DELETE_FAILURE]: (state, { error }) => ({
    ...state,
    uploadHasError: true,
    error,
  }),
  [TYPES.REQUEST_FILE_UPLOAD]: state => ({
    ...state,
    uploadHasError: false,
    uploading: true,
  }),
  [TYPES.REQUEST_FILE_UPLOAD_SUCCESS]: state => ({
    ...state,
    uploading: false,
  }),
  [TYPES.REQUEST_FILE_UPLOAD_FAILURE]: (state, { error }) => ({
    ...state,
    uploadHasError: true,
    uploading: false,
    error,
  }),
  [TYPES.INIT_FILE_UPLOAD]: state => ({
    ...state,
    uploadHasError: false,
  }),
  [TYPES.INIT_FILE_UPLOAD_SUCCESS]: (state, { ownerTypes, documentTypes }) => ({
    ...state,
    ownerTypes,
    documentTypes,
    documentTypesById: {
      ...keyBy(documentTypes, 'FileRepositoryObjectDocumentTypeID'),
      0: { Name: 'Ekkert', Value: 'None' },
    },
    documentTypesByValue: keyBy(documentTypes, 'Value'),
  }),
  [TYPES.INIT_FILE_UPLOAD_FAILURE]: (state, { error }) => ({
    ...state,
    uploadHasError: true,
    error,
  }),
  [TYPES.REQUEST_FILE_BY_ID]: state => ({
    ...state,
    loaded: false,
    error: false,
  }),
  [TYPES.REQUEST_FILE_BY_ID_SUCCESS]: (state, { fileById }) => ({
    ...state,
    fileById,
    loaded: true,

  }),
  [TYPES.REQUEST_FILE_BY_ID_FAILURE]: (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/FileReducer.js